<template>
  <div
    :class="{'is-loading': itemLoading, 'is-read': item.read_status}"
    class="Notification-item"
  >
    <div class="Notification-itemContainer">
      <a
        :href="item.url"
        class="Notification-itemLink"
      >
        <div class="SubHeader">
          <svg
            :class="['Notification-icons Notification--icon'+itemTypeText.type]"
          >
            <use :xlink:href="'#'+itemTypeText.type" />
          </svg>
          {{ itemTypeText.text }}
        </div>
        <div class="Notification-itemTitle">{{ getItemTitle }}</div>
        <div
          v-if="item.type !== 'companies'"
          class="SubHeader"
        >{{ item.company }}</div>
      </a>
      <div class="Notification-ctaFollow">
        <a
          v-if="!item.is_saved_company"
          href="#"
          @click.prevent="followCompany"
        ><span>Save Company</span></a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      itemLoading: false,
    };
  },
  computed: {
    getItemTitle() {
      return this.item.type !== 'companies' ? this.item.title : this.item.company;
    },
    itemTypeText() {
      switch (this.item.type) {
        case 'companies':
          return { type: 'Company', text: 'Company Saved' };
        case 'reviews':
          return { type: 'Review', text: 'Review Saved' };
        case 'jobs':
        default:
          return { type: this.item.is_pre_reg_job === true ? 'Ryi' : 'Job', text: this.item.is_pre_reg_job === true ? 'Interest registered' : 'Job Saved' };
      }
    },
  },
  methods: {
    ...mapActions('notification', {
      updateReadStatus: 'updateReadStatus',
    }),
    ...mapActions('savedItems', {
      addItem: 'addItem',
    }),
    followCompany() {
      this.itemLoading = true;
      // Todo @dom
      this.$gtag.send({
        event: 'flash-message',
        action: 'follow-click',
      });

      const payload = {
        type: 'companies',
        company: this.item.company,
        id: this.item.compId,
      };
      this.addItem(payload)
        .then(() => {
          this.itemLoading = false;
          this.updateReadStatus({ companies: [payload.id] });
        })
        .catch(() => {
          this.itemLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../scss/abstracts/abstracts";
  /*item*/
  .Notification-item {
    position: relative;
    background: #eceff0;
    &.is-read{
      background: #FFFFFF;
    }
    &:focus,
    &:hover {
      background: #f5f5f5;
    }
    &:last-child {
      .Notification-itemContainer {
        border-bottom: none;
      }
    }

    &.is-loading{
      &:before,
      &:after{
        opacity: 1;
        content: '';
        position: absolute;
      }
      &:after{
        top: 1px;
        right: 1px;
        bottom: 1px;
        left: 1px;
        background: rgba(255,255,255,.8);
      }
      &:before{
        top: 50%;
        z-index: 1;
        left: 50%;
        width: 20px;
        height: 20px;
        margin-top: -10px;
        margin-left: -10px;
        border-radius: 50%;
        line-height: 20px;
        text-align: center;
        border: 3px solid rgba(255, 255, 255, 0.2);
        border-left: 3px solid color($primary-color);
        opacity: 1;
        animation: load 1.1s infinite linear;
      }

    }
  }

  .Notification-itemContainer {
    border-bottom: 1px solid #E2E2E2;
    margin: 0 8px;
    padding: 8px;
  }
  .Notification-itemTitle{
    color:#434a4f;
    &:hover{
      color: color($primary-color);
    }
  }

.Notification-ctaFollow{
  margin-top: 8px;}
  .SubHeader {
    font-size: 14px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    color: rgba(32, 32, 32, 0.60);
  }

  .Notification-icons{
    width: 16px;
    margin-right: 6px;
    height:14px;
  }

  .Notification--iconJob{
      fill: #FF3F3F;
    }
  .Notification--iconReview{
    fill: #FFA732;
  }
  .Notification--iconCompany{
    fill: #32B056;
  }
  .Notification--iconRyi{
    fill:  #005cb3;
  }
  @keyframes load {
    0% {
      transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
    }
  }
</style>
